// Per-browser preferences (language, appearance). Stored in localStorage; everything works without it.

export type ThemeChoice = 'system' | 'light' | 'dark';
export type LangChoice = 'system' | 'de' | 'en';

export function loadPref(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function savePref(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch { /* private mode: the choice lasts until reload */ }
}

export function themeChoice(): ThemeChoice {
  const v = loadPref('tally.theme');
  return v === 'light' || v === 'dark' ? v : 'system';
}

export function langChoice(): LangChoice {
  const v = loadPref('tally.lang');
  return v === 'de' || v === 'en' ? v : 'system';
}

/** Explicit light or dark sets `data-theme` (tokens.css); "system" follows prefers-color-scheme. */
export function applyTheme(choice: ThemeChoice): void {
  if (choice === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = choice;
}
